import { Redirect } from 'react-router-dom';
import { useQuery } from 'react-query';

import useSessionStore from 'src/stores/session';
import { ROUTES_URL } from 'src/constants/routes';
import useUserStore from 'src/stores/user';

export default function MainRoute() {
    const isAuthorized = useSessionStore(({ isAuthorized }) => isAuthorized);
    const isOnboardingCompleted = useUserStore(({ isOnboardingCompleted }) => isOnboardingCompleted);
    const { getUserSessionRequiredData } = useSessionStore(({ getUserSessionRequiredData }) => ({
        getUserSessionRequiredData,
    }));

    // Используем кеш из react-query - если данные уже загружены, запрос не выполнится
    const { isLoading } = useQuery('user', getUserSessionRequiredData, {
        enabled: isAuthorized, // Загружаем только если авторизован
        staleTime: 30000, // Данные считаются свежими 30 секунд
        cacheTime: 60000, // Кеш хранится 60 секунд
    });

    if (!isAuthorized) return <Redirect to={ROUTES_URL.LOGIN} />;

    // Не показываем редирект пока загружаются данные (только при первой загрузке)
    if (isLoading) return null;

    if (!isOnboardingCompleted) return <Redirect to={ROUTES_URL.BEGIN_WORK} />;

    return <Redirect to={ROUTES_URL.FEED} />;
}
